// global variable
export let builderData = {
  OnboardingData: [],
  Events: [],
  Classes: [],
};
export const StyleObj = {};
